"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reglement = require("@/api/reglement");

var _ReglementForm = _interopRequireDefault(require("./components/ReglementForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
var _default = {
  // 1. Effets de bord
  // --
  // 2. Informations globales
  // --
  name: 'ReglementEdit',
  // 3. Type de composant
  // --
  // 4. Modificateurs de template
  // --
  // 5. Dépendances des templates
  // --
  components: {
    ReglementForm: _ReglementForm.default
  },
  // 6. Composition
  // --
  // 7. Interface
  // --
  props: {
    id: Number
  },
  // 8. État local (propriétés réactives locales)
  // --
  data: function data() {
    return {
      action: 'edit',
      dataLoaded: false,
      formData: {},
      title: 'Modifier un règlement'
    };
  },
  // 9. Évènements
  // --
  created: function created() {
    this.loadData();
  },
  // 10. Propriétés non réactives
  // --
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.$loader(true);
      (0, _reglement.getById)(this.id).then(function (results) {
        _this.formData = results[0];
        _this.dataLoaded = true;
      }).catch(function (err) {
        _this.$message(err);
      }).then(function (_) {
        _this.$loader(false);
      });
    }
  } // 11. Rendu
  // --

};
exports.default = _default;